import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Table from 'antd/lib/table';
import { ResponsiveTable } from '../../common/components/data-display';
import PagesLayout from './PagesLayout';

const columns = [
  {
    title: 'Služba',
    dataIndex: 'service',
    key: 'service',
  },
  {
    title: 'Cena',
    dataIndex: 'cost',
    key: 'cost',
  },
  {
    title: 'Dátum účinnosti',
    dataIndex: 'date',
    key: 'date',
  }
];

const data = [
  {
    key: '1',
    service: 'Poplatok za zabezpečenie poskytnutia prvej pôžičky',
    cost: '6.4 % z celkovej výšky pôžičky (minimálne 20 EUR)',
    date: '01.04.2025',
  },
  {
    key: '2',
    service: 'Poplatok za zabezpečenie poskytnutia  druhej a každej ďalšej pôžičky',
    cost: '3.4 % z celkovej výšky pôžičky (minimálne 20 EUR)',
    date: '01.04.2025',
  },
  {
    key: '3',
    service: 'Za predčasné splatenie',
    cost: '5% z predčasne splatenej sumy',
    date: '01.02.2018',
  },
  {
    key: '4',
    service: 'Druhé a ďalšie nasledujúce vyčíslenie zostatku pôžičky',
    cost: '10€',
    date: '01.02.2018',
  },
  {
    key: '5',
    service: 'Každá upomienka za omeškanie so splátkou alebo jej časťou ',
    cost: '',
    date: '01.02.2018',
  },
  {
    key: '6',
    service: <span style={{ paddingLeft: 50 }}>SMS</span>,
    cost: '3€',
    date: '01.02.2018',
  },
  {
    key: '7',
    service: <span style={{ paddingLeft: 50 }}>e-mail</span>,
    cost: '2€',
    date: '01.02.2018',
  },
  {
    key:'8',
    service: <span style={{ paddingLeft: 50, display:"inline-block" }}>telefonická úpomienka</span>,
    cost: '5€',
    date: '01.10.2020',
  },
  {
    key: '9',
    service: <span style={{ paddingLeft: 50, display:"inline-block" }}>listová zásielka</span>,
    cost: '10€',
    date: '01.02.2018',
  },
  {
    key: '10',
    service: 'Predčasné vyplatenie investície',
    cost: '2% z predčasne vyplatenej istiny',
    date: '01.02.2018',
  },
  
];


const Cennik = ({ t }) => (
  <PagesLayout noImg>
    <h2>{t('Cenník')}</h2>
    <Table columns={columns} dataSource={data} pagination={false} showHeader={columns[2].title === 'Dátum účinnosti' ? true : false} bordered className="responsive-table"/>
  </PagesLayout>
);

Cennik.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(Cennik);



// WEBPACK FOOTER //
// ./src/features/pages/Cennik.js